import { z } from 'zod'

export const MonetaBankCredentialsFormSchema = z.object({
  // name: z.string().optional(),
  token: z.string().min(1, {
    message: 'moneta.form.token.required',
  }),
})
